import * as dialog from '@zag-js/dialog';
import { useMachine, normalizeProps } from '@zag-js/vue';
import { useId, computed, toValue } from 'vue';
import { useEnvironmentContext, DEFAULT_ENVIRONMENT } from '../../providers/environment/use-environment-context.js';
import { useLocaleContext, DEFAULT_LOCALE } from '../../providers/locale/use-locale-context.js';
import { cleanProps } from '../../utils/clean-props.js';

const useDialog = (props = {}, emit) => {
  const id = useId();
  const env = useEnvironmentContext(DEFAULT_ENVIRONMENT);
  const locale = useLocaleContext(DEFAULT_LOCALE);
  const context = computed(() => {
    const localeProps = toValue(props);
    return {
      id,
      dir: locale.value.dir,
      getRootNode: env?.value.getRootNode,
      ...cleanProps(props),
      onOpenChange: (details) => {
        emit?.("openChange", details);
        emit?.("update:open", details.open);
        localeProps.onOpenChange?.(details);
      },
      onEscapeKeyDown: (details) => {
        emit?.("escapeKeyDown", details);
        localeProps.onEscapeKeyDown?.(details);
      },
      onFocusOutside: (details) => {
        emit?.("focusOutside", details);
        localeProps.onFocusOutside?.(details);
      },
      onInteractOutside: (details) => {
        emit?.("interactOutside", details);
        localeProps.onInteractOutside?.(details);
      },
      onPointerDownOutside: (details) => {
        emit?.("pointerDownOutside", details);
        localeProps.onPointerDownOutside?.(details);
      }
    };
  });
  const service = useMachine(dialog.machine, context);
  return computed(() => dialog.connect(service, normalizeProps));
};

export { useDialog };
